import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Gpay from "assets/images/gpay-note.png";
import Paytm from "assets/images/paytm-note.png";
import PhonePe from "assets/images/phonepe-ref.png";
import colors from "styles/colors";

const UtrDetails = () => [];
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const NoteTabs = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="how to find utr"
        >
          <Tab style={{ fontSize: 12 }} label="PHONEPE" {...a11yProps(0)} />
          <Tab style={{ fontSize: 12 }} label="GOOGLEPAY" {...a11yProps(1)} />
          <Tab style={{ fontSize: 12 }} label="PAYTM" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <div style={{ paddingBottom: 16 }}>
          <Typography
            fontSize={12}
            paddingBottom={0.5}
            color={colors.Grey.title}
          >
            1. On payment page, type the amount
          </Typography>
          <Typography
            fontSize={12}
            paddingBottom={0.5}
            color={colors.Grey.title}
          >
            2. In the <strong>'Add a Note'</strong> box below the amount, enter
            the 4 digit number
          </Typography>
        </div>
        <img style={{ width: 300, height: 150 }} src={PhonePe} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <div style={{ paddingBottom: 16 }}>
          <Typography
            fontSize={12}
            paddingBottom={0.5}
            color={colors.Grey.title}
          >
            1. On payment page, type the amount
          </Typography>
          <Typography
            fontSize={12}
            paddingBottom={0.5}
            color={colors.Grey.title}
          >
            2. In the <strong>'Add a Note'</strong> box below the amount, enter
            the unique code
          </Typography>
        </div>
        <img style={{ width: 300, height: 200 }} src={Gpay} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <div style={{ paddingBottom: 16 }}>
          <Typography
            fontSize={12}
            paddingBottom={0.5}
            color={colors.Grey.title}
          >
            1. On payment page, type the amount
          </Typography>
          <Typography
            fontSize={12}
            paddingBottom={0.5}
            color={colors.Grey.title}
          >
            2. In the <strong>'Add a Note'</strong> box below the amount, enter
            the unique code
          </Typography>
        </div>
        <img style={{ width: 300, height: 200 }} src={Paytm} />
      </CustomTabPanel>
    </Box>
  );
};

export default NoteTabs;
